export default "/images/f0916efcc2401f2334b81517e4e6393a.avif";